import { observer } from 'mobx-react-lite';
import Image from 'next/legacy/image';
import router from 'next/router';

import { Price } from '@/components/productDetails/Price/Price';
import type { ProductModelType } from '@/models/api';
import { useStore } from '@/models/root-store';
import { Action, Mode } from '@/utils/constants';

type MobileProductInfoCardType = { product: ProductModelType };

const MobileProductInfoCard: React.FC<MobileProductInfoCardType> = observer(
  ({ product }) => {
    const {
      cartStore: { cart, draftCart },
      productStore: { productsLookup },
    } = useStore();
    const { action } = router.query;
    const cartToUse =
      draftCart.mode === Mode.EDIT_SUBSCRIPTION ||
      action === Action.VIEW ||
      action === Action.VIEW_WLP ||
      action === Action.ADD_EXTRA ||
      action === Action.SWAP_ITEM
        ? draftCart
        : cart;
    const { menuBuilderPlan } = cartToUse;
    const images = product.cms?.displayPageImages;
    const item = productsLookup[product.sku];
    const itemDiscount =
      item && item.getDiscountedPrice(menuBuilderPlan?.discount);
    return (
      <>
        <div className="flex w-full items-center justify-between px-4 py-3">
          <div className="flex items-center justify-between space-y-4">
            <Image
              className="rounded-lg"
              width="62"
              height="62"
              src={images[0].url}
              alt={''}
            />
            <div className="flex flex-col justify-center">
              <h5 className="mx-4 mt-1 line-clamp-2 max-w-[167px] items-start font-interSemibold text-xs leading-5">
                {product.cms?.primaryName}
              </h5>
              <h3 className="mx-4 pb-5 font-interMedium text-xs text-grey-midnight">
                {product.cms?.secondaryName}
              </h3>
            </div>
          </div>
          <div className="text-sm">
            <Price
              discount={menuBuilderPlan?.discount}
              discountedAmount={itemDiscount}
              grossPrice={product.grossPrice || 0}
              smallTile={true}
              hasSubProducts={product.hasSubProducts || false}
              promotionTotal={product.promotionTotal}
              isBulkDiscountable={product.isBulkDiscountable}
            />
          </div>
        </div>
      </>
    );
  },
);

export default MobileProductInfoCard;
